"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dispatchEvent;

function dispatchEvent(eventName) {
  var p = 'events/' + eventName;
  var action;

  try {
    action = require(p).default;
  } catch (e) {
    action = function action() {};
  }

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return action.apply(void 0, args);
}